window.theme = window.theme || {}

theme.generateToc = function (elemtSearch = 'js-generate__toc'){
    let data    = [];
    let i       = 0;
    const slugify = require('slugify');
    $('.'+elemtSearch).find('h2, h3, h4, h5, h6').each(function(){
        let str = $(this).html();
        str = theme.removeTags(str);
        let idHeading   = slugify(str, {
            replacement: '-',
            remove: undefined,
            lower: true,
            strict: true,
            locale: 'vi',
            trim: true
        });
        // if(idHeading == null) idHeading = 'buildTocContent_'+i;
        $(this).attr('id', idHeading).removeAttr('style');
        data.push({
            type    : this.nodeName,
            content : str,
            id      : idHeading
        });
        ++i;
    });

    $.ajax({
        url         : window.FleetCart.baseUrl+'/action/generate/toc',
        type        : 'post', 
        dataType    : 'json',
        data        : {
            _token  : window.FleetCart.csrfToken,
            data    : data,
            urlCurrent: window.FleetCart.urlCurrent
        },
        success     : function(response){
            $('#tocContent').html(response.data);
            theme.fixedTocContentIcon();
            theme.setHeightTocFixed();

            $(window).resize(function() {
                theme.fixedTocContentIcon();
                theme.setHeightTocFixed();
            });

            $('.tocFixedIcon, .tocContent.tocFixed .tocContent_close').click(function(){
                $('.tocContent.tocFixed').toggleClass('active');

                if ($('.tocContent.tocFixed').hasClass('active')) {
                    $('.overlay-body').removeClass('d-none');
                } else {
                    $('.overlay-body').addClass('d-none');
                }

            });

            $('.tocContent_title, .tocContent_close').click(function(){
                let elemtMenu   = $('.tocContent .tocContent_list');
                let displayMenu = elemtMenu.css('display');
                if(displayMenu=='none'){
                    elemtMenu.css('display', 'block');
                    $('.tocContent_close').removeClass('hidden');
                }else {
                    elemtMenu.css('display', 'none');
                    $('.tocContent_close').addClass('hidden');
                }
            });

            theme.fixedTocContentIcon();
            theme.setHeightTocFixed();

            let element     = $('.tocContent');
            let positionE   = element.offset().top;
            let heightE     = element.outerHeight();
            let boxContent  = $('.'+elemtSearch);
            let positionB   = boxContent.offset().top;
            let heightB     = boxContent.outerHeight();
            $(document).scroll(function(){
                let scrollNow   = $(document).scrollTop();
                let minScroll   = parseInt(heightE + positionE);
                let maxScroll   = parseInt(heightB + positionB);
                if(scrollNow > minScroll && scrollNow < maxScroll){ 
                    $('.tocFixedIcon').css('display', 'block');
                }else {
                    $('.tocFixedIcon').css('display', 'none');
                }
            });
        }
    });
}

theme.removeTags = function(str) {
    if ((str === null) || (str === ''))
        return false;
    else
        str = str.toString();
    return str.replace(/(<([^>]+)>)/ig, '');
}

theme.fixedTocContentIcon = function () {
    let widthS      = $(window).width();
    let widthC      = $('.js-detail__content').outerWidth();
    let widthE      = $('.tocFixedIcon').outerWidth();
    let widthSidebar      = $('.posts-sidebar').outerWidth();
    let leftE       = parseInt((widthS - widthC - widthE - 20) / 2) + widthSidebar + 25;
    if($(window).width() < 1200){
        leftE       = parseInt((widthS - widthC - widthE + 30) / 2);
    }
    
    $('.tocFixedIcon').css('right', leftE);
}

theme.setHeightTocFixed = function setHeightTocFixed(){
    let heightToc   = parseInt($(window).height() - 210);
    // $('.tocContent.tocFixed .tocContent_list').css('height', heightToc+'px');
}

theme.init = function () {
    if($('.js-generate__toc').length > 0) {
        theme.generateToc();
    }
}

$(function() {
    $(theme.init) 

    const header = $('.header-wrapper');
    const headerHeight = header.outerHeight();
    const offset = 40;
    const _js_generate__toc = $('.js-generate__toc');

    function onScroll() {
        let currentSection = null;
    
        $('h1, h2, h3, h4, h5, h6', _js_generate__toc).each(function () {
            const sectionTop = $(this).offset().top;
            const scrollPos = $(window).scrollTop();
            if (scrollPos >= sectionTop - headerHeight - offset) {
                currentSection = this;
            }
        });
    
        if (currentSection) {
            let id = $(currentSection).attr('id');
            let targetHref = `#${id}`;
    
            $('#toc a').removeClass('active');
            $('#toc a').each(function () {
                let linkHref = $(this).attr('href');
                if (linkHref.endsWith(targetHref)) {
                    $(this).addClass('active');
                }
            });
        }
    }
    

    $(window).on('scroll', onScroll);

    onScroll();
});